import { render, staticRenderFns } from "./Dashboard4.vue?vue&type=template&id=fbb16b12"
import script from "./Dashboard4.vue?vue&type=script&lang=js"
export * from "./Dashboard4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports